import { Box, Typography, styled } from '@mui/material';
import { ProductAddonSearch } from 'models/ProductSearch';
import { ProductAddonCard } from './ProductAddonCard';
import { useTranslation } from 'react-i18next';

const CollectionItem = styled(Box)(() => ({
    padding: '5px',
    alignItems: 'stretch',
}));

const ProductAdditionalItems: React.FC<ProductAdditionalItemsProps> = (
    props
) => {
    const { t } = useTranslation('product', {
        keyPrefix: 'PRODUCT.TABS.ADDONS',
    });

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                overflowX: 'auto',
            }}
        >
            <Typography variant="h3" gutterBottom>
                {t('ADDITIONAL_ITEMS')}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '4px',
                    width: props.additionalItems.length > 3 ? '100%' : '65%',
                }}
            >
                {props.additionalItems.map((item, key) => {
                    return (
                        <CollectionItem
                            key={item.id}
                            sx={{
                                width: '33%',
                            }}
                        >
                            <ProductAddonCard
                                key={key}
                                product={item}
                                handle={''}
                            />
                        </CollectionItem>
                    );
                })}
            </Box>
        </Box>
    );
};

export default ProductAdditionalItems;

type ProductAdditionalItemsProps = {
    additionalItems: ProductAddonSearch[];
};
